<template>
  <div class="container">
    <layout-container-header></layout-container-header>
    <slot></slot>
  </div>
</template>
<script>
export default {
  name: 'layoutContainer',
  mounted () {
    this.$store.dispatch('getUserInfo')
  }
}
</script>
<style lang="scss" scoped>
  .container {
    flex: 1;
    display: flex;
    flex-direction: column;
    background-color: #ffffff;
    overflow: auto;
  }
</style>



// WEBPACK FOOTER //
// src/components/layout/container/index.vue